import { render, staticRenderFns } from "./RegisteredWithoutToken.vue?vue&type=template&id=bd806554"
import script from "./RegisteredWithoutToken.vue?vue&type=script&lang=ts"
export * from "./RegisteredWithoutToken.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@corefy+vue2-vue-template-compiler@2.7.24_css-loader@6.8.1_webpack@5_b8049d8d702ee6dc36dae9749dee35d1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports